
export const customFormatDate = (d, format = '') => {
    let formatDate = new Date(d),
        year = formatDate.getFullYear(),
        month = formatDate.getMonth() + 1,
        date = formatDate.getDate(),
        newDate = '';

    if(parseInt(month) < 10) month = '0' + month;
    if(parseInt(date) < 10) date = '0' + date;
    if(format === ''){
        newDate = year+'/'+month+'/'+date;
    }else{
        newDate = format;
        if(format.includes('YYYY')){
            newDate = newDate.replace('YYYY',year);
        }
        if(format.includes('MM')){
            newDate = newDate.replace('MM', month);
        }
        if(format.includes('DD')){
            newDate = newDate.replace('DD', date);
        }                
    }
    return newDate;
}

export const customFormatMonth = (d) => {
    let formatDate = new Date(d),
        year = formatDate.getFullYear(),
        month = formatDate.getMonth() + 1

    return year+'年'+month+'月';
}
export const parseTimeToNum = (time) => {
    if(!time.includes(':')) return time;
    let newTime = time.replace(':', '');
    return parseInt(newTime)
}
export const isSameMonth = (a, b) => {
    let firstDate = new Date(a),
        secondDate =  new Date(b),
        flagCheck = false;
    if(firstDate.getMonth() === secondDate.getMonth() && firstDate.getFullYear() === secondDate.getFullYear()){
        flagCheck = true;
    }
    return flagCheck;
}
export const isSameDate = (a, b , before = false) => {
    let firstDate = new Date(a),
        secondDate =  new Date(b),
        flagCheck = false;
    if(before){
        flagCheck = firstDate.getTime() <= secondDate.getTime()
    }else{
        flagCheck = firstDate.getTime() === secondDate.getTime()
    }
    return flagCheck
}

export const isSameOrBeforeDate = (a, b) => {
    return isSameDate(a, b, true)
}
export const isSameOrAfter = (first, second, isSame = true) => {
    let timeStampFirst = new Date(first).getTime(),
        timeStampSecond = new Date(second).getTime();
    return isSame ? timeStampFirst <= timeStampSecond : timeStampFirst < timeStampSecond;
}
export const comparingDate = (a, b) => {
    let earlier  = new Date(customFormatDate(a)),
        later  =  new Date(customFormatDate(b));
    return earlier < later ;
}

export const addMinute = (time, block) => {
    let newTime = time.split(':'),        
        totalMinute = parseInt(newTime[1]) + block,
        newMinute = totalMinute % 60,
        newHour = parseInt(newTime[0]) + Math.floor(totalMinute/60);
        if(newMinute < 10) {
            newMinute = '0' + newMinute;
        }
        if(newHour < 10){
            newHour = '0' + newHour;
        }
    return newHour + ':' + newMinute;
}

export const checkTimeBefore = (f,t, same = false) => {
    let to = parseTimeToNum(t),
        from = parseTimeToNum(f);
    if(from >= to && !same)  return false;
    if(from > to && same) return false
    return true;
}
export const checkTimeAfter = (t,f) => {
    let to = parseTimeToNum(t),
        from = parseTimeToNum(f);
    if(from >= to)  return false;
    return true;
}

export const checkOverTime = (time) => {
    if(time){
        let newTime = time && time.split(':');
        if(parseInt(newTime[0]) > 23) {
            return true;
        }
    }
    
    return false
}

export const convertOverTime = (time) => {    
    if(checkOverTime(time)){
        let newTime = time.split(':'),
        newHour = 0;
        newHour = parseInt(newTime[0]) - 24;
        newHour = '翌'+newHour;
        time = newHour + ':' + newTime[1];
    }
    return time
}

export const getIndexDay = (date) => {
    let formatDate = new Date(date);
    return formatDate.getDay();
}

export const customAddDate = (date, number) => {
    let formatDate = new Date(date),
        resultDate = new Date(date);
    resultDate.setDate(formatDate.getDate() + number);

    return resultDate
}

export const customSubDate = (date, number) => {
    let formatDate = new Date(date),
        resultDate = new Date(date);
    resultDate.setDate(formatDate.getDate() - number);

    return resultDate
}

export const customDiffDate = (a, b, type='date') => {    
    let tempTime = type === 'date' ? 1000*60*60*24 : 1000*60,
        formatFirstDate = new Date(a),
        formatSecondDate = new Date(b),
        diffNum =  parseInt(formatSecondDate.getTime() - formatFirstDate.getTime());
        diffNum = diffNum / tempTime;
    return parseInt(diffNum)
}

export const convertFullTime = (date, time) => {
    let stringTime = time.split(':'),
        hourOfTime = stringTime[0],
        minutesOfTime = stringTime[1];
    if(parseInt(hourOfTime) < 24){
        return customFormatDate(date) + ' ' + time + ':00';
    }
    let newHour = parseInt(hourOfTime) - 24;
    const dateFull = new Date(date),
        newDate = new Date(date);
    newDate.setDate(dateFull.getDate() + 1);    
    return customFormatDate(newDate) + ' 0' + newHour + ':' + minutesOfTime + ':00';
}

export const getFirstDateofWeek = (firstDate, date) => {
    let newDate = firstDate,
        tempDate = firstDate,
        checkBeforeDate = isSameDate(tempDate, date, true);
    while(checkBeforeDate){
        newDate = tempDate;
        tempDate = customAddDate(tempDate, 7),
        checkBeforeDate = isSameDate(tempDate, date, true);
    }
    return customFormatDate(newDate);
}